import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { ROLES } from "../../game/roles";
import { ROLE_ICONS, ROLE_COLORS, ROLE_INK } from "./roleIcons";
import { Avatar } from "./Avatar";
import { SLOT_POP_FROM, SLOT_SETTLE } from "./motionPresets";

const SlotIcon = ({ role, character, color }) => {
  if (character) return <Avatar name={character.name} size={34} />;
  const Icon = ROLE_ICONS[role.key];
  return (
    <span
      className="w-[34px] h-[34px] rounded-full flex items-center justify-center shrink-0"
      style={{ background: `${color}22` }}
    >
      <Icon size={16} style={{ color: ROLE_INK[role.key] }} />
    </span>
  );
};

const SlotText = ({ role, character, color }) => (
  <div className="min-w-0 flex-1">
    <p className="label-mono text-[9px] flex items-center gap-1" style={{ color: ROLE_INK[role.key] }}>
      {role.label}
      {character && <Lock size={9} />}
    </p>
    <p
      className={`text-[13px] font-semibold truncate ${character ? "text-[#14233D]" : "text-[#5E5E8A]"}`}
      data-testid={`slot-${role.key}-name`}
    >
      {character ? character.name : "Libero"}
    </p>
  </div>
);

const slotClass = (character, wide) =>
  `slot relative overflow-hidden rounded-[20px] border px-3 py-2.5 flex flex-wrap items-center gap-2.5 min-h-[60px] ${
    wide ? "col-span-2" : ""
  } ${character ? "slot-filled" : "slot-empty"}`;

const Slot = ({ role, character, isNew, wide }) => {
  const color = ROLE_COLORS[role.key];
  return (
    <motion.div
      key={character ? character.id : "empty"}
      data-testid={`slot-${role.key}`}
      initial={isNew ? SLOT_POP_FROM : false}
      {...SLOT_SETTLE}
      style={character ? { borderColor: color, boxShadow: `0 4px 0 ${color}55` } : undefined}
      className={slotClass(character, wide)}
    >
      {isNew && <span className="slot-flash" />}
      <SlotIcon role={role} character={character} color={color} />
      <SlotText role={role} character={character} color={color} />
      {role.hint && (
        <p className="role-hint basis-full text-[#506780] line-clamp-2 -mt-1" data-testid={`slot-hint-${role.key}`}>
          {role.hint}
        </p>
      )}
    </motion.div>
  );
};

export const SlotBoard = ({ assignments, lastFilled }) => (
  <section data-testid="slot-board">
    <p className="label-mono text-[#7433C1] mb-3">La tua ciurma</p>
    <div className="grid grid-cols-2 gap-2">
      {ROLES.map((role, i) => (
        <Slot
          key={role.key}
          role={role}
          character={assignments[role.key]}
          isNew={lastFilled === role.key}
          wide={i === ROLES.length - 1}
        />
      ))}
    </div>
  </section>
);
